import React from 'react';

import { faDownload, faUpload, faFileExcel, faSquareFull, faPlusSquare, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Header, HeaderGroup, HeaderItem, HeaderLanguageToggler, HeaderDropdown as OceanHeaderDropdown, HeaderDropdownItem } from '@oceanjs/ui-bootstrap-header';

import { Routes } from '../../../Routes';
import { Permissions } from '../../../Permissions';
import { PermissionComponent } from '../../Common/PermissionComponent';
import { DownloadDropdownItem } from '../../Navigation';
import { ExcelService } from '../../../api';
import FileSaver from 'file-saver';
import { useDownloaderContext } from '../../Downloader';
import { WisaUserController } from '../../WisaUserMgmt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HeaderDropdown } from '../../../framework';

export const AppHeader: React.FC = () => {
  const { addDownload } = useDownloaderContext();

  return (
    <Header name="Parametercodierung" className="bg-primary" fixed={false}>
      <HeaderGroup className="d-md-down-none">
        <HeaderDropdown className="mr-1" id="parameter_mgmt" 
          onRenderIcon={() => 
            <span className="fa-layers fa-fw">
              <FontAwesomeIcon icon={faSquareFull} />
              <span className="fa-layers-text fa-inverse" style={{fontWeight:900}}>P</span>
            </span>
          }>
          <HeaderDropdownItem
            icon={faSearch}
            id="parameter_manager"
            to={`#${Routes.ParameterMgmt}`}
            messageId={null}
          />
          <PermissionComponent permission={[Permissions.ParameterKomponenteCreate]}>
            <HeaderDropdownItem
              icon={faPlusSquare}
              id="parameter_add"
              to={`#${Routes.ParameterNew}`}
              messageId={null}
            />
          </PermissionComponent>
        </HeaderDropdown>

        <HeaderDropdown className="mr-1" id="components_mgmt"
          onRenderIcon={() => 
            <span className="fa-layers fa-fw">
              <FontAwesomeIcon icon={faSquareFull} />
              <span className="fa-layers-text fa-inverse" style={{fontWeight:900}}>K</span>
            </span>
          }>
          <HeaderDropdownItem
            icon={faSearch}
            id="components_manager"
            to={`#${Routes.ComponentMgmt}`}
            messageId={null}
          />

          <PermissionComponent permission={[Permissions.ParameterKomponenteCreate]}>
            <HeaderDropdownItem
              icon={faPlusSquare}
              id="components_add"
              to={`#${Routes.ComponentNew}`}
              messageId={null}
            />
          </PermissionComponent>
        </HeaderDropdown>

        <OceanHeaderDropdown className="mr-1" id="file_download" icon={faDownload}>
          <DownloadDropdownItem
            icon={faFileExcel}
            id="file_download_list"
            onClick={() => {
              addDownload({
                progress: 50,
                action: async () => {
                  return new Promise<void>(async (resolve, reject) => {
                    const response = await ExcelService.getExcelExport();
                    if (response) {
                      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                      FileSaver.saveAs(blob, 'EHPC-Daten.xlsx');
                      resolve();
                    }
                    reject();
                  });
                }
              });
            }}
          />
        </OceanHeaderDropdown>

        <PermissionComponent permission={[Permissions.FileUpload]}>
          <HeaderItem
            icon={faUpload}
            id="upload_manager"
            to={Routes.Uploads}
            messageId={null}
          />
        </PermissionComponent>
      </HeaderGroup>

      <HeaderGroup className="ml-auto">
        
        <WisaUserController id="wisa-user" />
        <HeaderLanguageToggler id="lang-toggler" />
      </HeaderGroup>
    </Header>
  );
};
